import { ComputedSuggestion } from './utils';

export const keyboardEventsKey = {
    ARROW_UP: 'ArrowUp' as const,
    ARROW_DOWN: 'ArrowDown' as const,
    ARROW_LEFT: 'ArrowLeft' as const,
    ARROW_RIGHT: 'ArrowRight' as const,
    ENTER: 'Enter' as const,
    ESCAPE: 'Escape' as const,
};

export const KeyboardDirectionsConst = [
    keyboardEventsKey.ARROW_UP,
    keyboardEventsKey.ARROW_DOWN,
    keyboardEventsKey.ARROW_LEFT,
    keyboardEventsKey.ARROW_RIGHT,
] as const;

export type KeyboardDirectionsType = (typeof KeyboardDirectionsConst)[number];

export const ListDirections = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
} as const;

export type ListDirectionsType = (typeof ListDirections)[keyof typeof ListDirections];

export enum NullStateSuggestionTypes {
    latestCollections = 'latestCollections',
    trendingCollections = 'trendingCollections',
}

export const suggestionTypesKey = {
    KEYWORDS: 'keywords' satisfies keyof ComputedSuggestion,
    WITHIN_ASSET: 'withinAssetContentTypeSuggestions' satisfies keyof ComputedSuggestion,
    RELATED_CONTENT_TYPE: 'relatedContentTypeSuggestion' satisfies keyof ComputedSuggestion,
    RELATED_COLLECTION: 'relatedCollections' satisfies keyof ComputedSuggestion,
    SUGGESTED_PAGES: 'suggestedPages' satisfies keyof ComputedSuggestion,
    ADOBE_PLUGIN: 'adobePluginLink' satisfies keyof ComputedSuggestion,
} as const;

export type suggestionTypes = (typeof suggestionTypesKey)[keyof typeof suggestionTypesKey];

export const ADOBE_PLUGIN_MARKETPLACE_URL = 'https://exchange.adobe.com/apps/cc/108662/storyblocks';

export const ADOBE_PLUGIN_LANDING_PAGE_RELATIVE_PATH = '/adobe-creative-cloud-plugin';
